import url from 'url';

function getOptimizelyUrlParam(canonical = '', query = {}, pg) {
    const parsedUrl = url.parse(canonical);
    // not adding query params otherwise
    delete parsedUrl.search;
    const urlFormatObj = {
        ...parsedUrl,
        query: {
            ...query,
            pg,
        },
    };
    return encodeURIComponent(url.format(urlFormatObj));
}

const getOptimizelyEdgeUrl = (
    canonical = '',
    query = {},
    pg = '',
    optimizelyBaseURL = 'https://www.autotrader.com/optmz-edge/'
) => optimizelyBaseURL + '?url=' + getOptimizelyUrlParam(canonical, query, pg);

export default getOptimizelyEdgeUrl;
